import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { HttpErrorDialog } from '../Dialogs/HttpErrorDialog/http-error-dialog';
import { environment } from '../../environments/environment';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class HttpClient {
  token: string;
  headers: any;

  constructor(
    private http: Http,
    private router: Router,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService
  ) {

    this.setToken();

    this.router.events.subscribe(event => {
      this.setToken();
    });

  }

  public setToken() {
    if (localStorage.getItem('currentUser') == null) {
      this.headers = new Headers();
    } else {
      this.token = this.authenticationService.getAuthCookie();
      if (!this.token) {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
      } else {
        this.headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
      }
    }
  };

  public dataMap(mapParams, isJson = true, skipErrorModal?: boolean) {
    return mapParams.map((response: Response) => {
      let data = null;
      if (isJson) {
        data = response.json();
      } else {
        data = response;
      }
      // const data = response;
      // console.log('http response: ', response.status);
      return data;
    })
      .catch(e => {
        if (e.status === 401) {
          localStorage.removeItem('currentUser');
          this.router.navigate(['/login']);
          return Observable.throw('Unauthorized');
        }

        if (!skipErrorModal && e.status === 500 && (!e.url.includes('/api/expanded/track/?group_id') || !e.url.includes('/api/expanded/track/?group_id'))) {
          console.warn('dataMap: ', e);
          this.handleError(e);
        }
        return Observable.throw(e);
      });
  }

  //
  get<T>(url: string, options?: RequestOptionsArgs, external?, forceHeaders?, isJson = true, skipErrorModal?: boolean) {
    if (!options) {
      options = {};
    }
    options['headers'] = forceHeaders ? forceHeaders : this.headers;
    return this.dataMap(this.http.get((!external ? environment.apiHost : '') + url, options), isJson, skipErrorModal);
  }

  post(url, data, forceHeaders?, external?, isJson: boolean = true) {
    return this.dataMap(
      this.http.post((!external ? environment.apiHost : '') + url, data, forceHeaders ? { headers: forceHeaders } : { headers: this.headers }),
      isJson
    );
  }

  put(url, data, isJson = true) {
    return this.dataMap(this.http.put(environment.apiHost + url, data, { headers: this.headers }), isJson);
  }



  patch(url, data) {
    return this.dataMap(this.http.patch(environment.apiHost + url, data, { headers: this.headers }));
  }

  delete(url, options?: RequestOptionsArgs) {
    if (!options) {
      options = {};
    }
    options['headers'] = this.headers;
    return this.dataMap(this.http.delete(environment.apiHost + url, options));
  }


  handleError(error: Response) {
    console.log('Http service error;');
    // TODO - Log errors to a logging service and DB
    this.openDialog(error);

  }

  openDialog(error: Response): void {
    const dialogRef = this.dialog.open(HttpErrorDialog, {
      width: '400px',
      data: error
    });
  }
}





// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/global-http.service.ts